import { LanguageType } from '@op/types/common';
import { dealwithBiLiBiLiImage } from '@op/utils/cdnUrl';
import { DBO_TM } from '@op/utils/format';
import {
  getFeedsContentText,
  getFeedsLiveContentText,
} from '@op/utils/languageValue';
import { keywordRenderFunc } from '@op/utils/text';
import { useCallback, useMemo } from 'react';
import videoCover from '@op/assets/svg/video-cover.svg';

export function useFeedsVideoData({
  data,
  language,
}: {
  data: any;
  language: LanguageType;
}) {
  const renderDuration = (durationStr: string) => {
    let curDurationStr = durationStr;
    if (/^(\d+)s*$/i.test(durationStr)) {
      curDurationStr = DBO_TM.duration(
        Number(String(durationStr).replace(/s/gi, '')),
      );
    }
    return curDurationStr;
  };

  const renderContent = useCallback(
    (records: any) =>
      keywordRenderFunc({
        text: getFeedsContentText(records, language),
      }),
    [language],
  );

  const videoInfo = useMemo(() => {
    const videoInfo = { cover_image: '', duration: '', url: '' };
    try {
      const obj = JSON.parse(data.video_detail);
      // 判断是否是B站图片
      obj.cover_image = dealwithBiLiBiLiImage(obj.cover_image);
      Object.assign(videoInfo, obj);
    } catch (error) {}

    return {
      videoDuration: renderDuration(videoInfo.duration),
      videoImage: videoInfo.cover_image,
      videoDefaultImage: videoCover,
      videoUrl: data.content_url,
      videoContent: renderContent(data),
      openVideoDetailPage: () => {
        if (!data.content_url) return;
        window.open(data.content_url);
      },
    };
  }, [renderContent, data]);

  return videoInfo;
}

export function useFeedsSteamingData({
  data,
  language,
}: {
  data: any;
  language: LanguageType;
}) {
  const renderDuration = (durationStr: string) => {
    let curDurationStr = durationStr;
    if (/^(\d+)s*$/i.test(durationStr)) {
      curDurationStr = DBO_TM.duration(
        Number(String(durationStr).replace(/s/gi, '')),
      );
    }
    return curDurationStr;
  };

  const renderContent = useCallback(
    (records: any) =>
      keywordRenderFunc({
        text: getFeedsLiveContentText(records, language),
      }),
    [language],
  );

  const videoInfo = useMemo(() => {
    const videoInfo = { thumbnail_url: '', duration: '', language: '' };
    try {
      let obj = JSON.parse(data?.ext_json);
      if (typeof obj === 'string') {
        obj = JSON.parse(obj);
      }
      // 判断是否是B站图片
      obj.thumbnail_url = dealwithBiLiBiLiImage(obj.thumbnail_url);
      Object.assign(videoInfo, obj);
    } catch (error) {}
    return {
      videoDuration: renderDuration(videoInfo.duration),
      videoImage: data?.anchors_image,
      videoDefaultImage: videoCover,
      videoUrl: data?.live_url,
      videoContent: renderContent(data),
      openVideoDetailPage: () => {
        if (!data?.live_url) return;
        window.open(data.live_url);
      },
    };
  }, [renderContent, data]);

  return videoInfo;
}
